'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfWeek;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/beginningOfWeek.js
// module id = 479
// module chunks = 0